"use client";

import type { ReactNode } from "react";
import type { TTSVoiceCollection } from "./types";

import dynamic from "next/dynamic";

const TTSFullPageClient = dynamic(() => import("./TTSFullPageClient").then(mod => mod.TTSFullPageClient));

export function TTSFullPageClientLazy({
  defaultLanguage,
  header,
  voiceCollections,
  voiceListSkeleton,
}: {
  defaultLanguage?: string;
  header?: ReactNode;
  voiceCollections: TTSVoiceCollection[];
  voiceListSkeleton: ReactNode;
}) {
  return (
    <TTSFullPageClient
      defaultLanguage={defaultLanguage}
      header={header}
      voiceCollections={voiceCollections}
      voiceListSkeleton={voiceListSkeleton}
    />
  );
}
